import { useEffect, useMemo, useState } from 'react';
import { DetailCard } from '../DetailCard';
import { isTiKTok } from 'lib/utils/isTikTok';
import toLowerCase from 'utils/toLowerCase';
import { useTranslate } from '@tolgee/react';
import { useQuery } from '@tanstack/react-query';
import { queries } from 'services/queries';
import { useSystemLanguageValue } from 'hooks/business/system/useSystem';
import { Button } from 'antd';
import { OrderProductList } from '../OrderCard/OrderProductList';
import { CommentCard } from '../OrderDetail/CommentCard';
import { CancelOrder } from 'services/api/refund';
import { OrderCancelDetailProps } from 'components/LightConversation/types';

export const OrderCancelDetailContent = (
  props: OrderCancelDetailProps & { cancelOrder: CancelOrder },
) => {
  const { order, orderQueryParams, cancelOrder } = props;
  const { t } = useTranslate();
  const systemLanguage = useSystemLanguageValue();
  const { orderState: cancelStatus } = cancelOrder;
  const { platform, cancelReason, items } = order;

  const [viewOriginal, setViewOriginal] = useState(true);

  const { isLoading, data: translatedCancelReason } = useQuery({
    ...queries.translates.overseaTranslate(cancelReason, systemLanguage, 'side'),
  });

  useEffect(() => {
    if (translatedCancelReason) {
      setViewOriginal(false);
    }
  }, [translatedCancelReason]);

  const statusLabel = useMemo(() => {
    if (isTiKTok(platform)) {
      return t(`tiktok.${cancelStatus}`, {
        defaultValue: cancelStatus,
      });
    } else {
      return t(`${toLowerCase(platform)}.${cancelStatus}`, {
        defaultValue: cancelStatus,
      });
    }
  }, [cancelStatus, platform, t]);

  const reason = viewOriginal ? cancelReason : translatedCancelReason || cancelReason;

  return (
    <div className="flex flex-col gap-4">
      <DetailCard title={statusLabel} />
      {reason && (
        <DetailCard
          loading={isLoading}
          title={reason}
          rightExtra={
            <Button type="link" className="!px-0" onClick={() => setViewOriginal(!viewOriginal)}>
              {viewOriginal ? t('trade.查看翻译') : t('trade.查看原文')}
            </Button>
          }
        />
      )}
      <DetailCard title={t('x个商品', { count: items.length })}>
        <OrderProductList
          order={order}
          products={items}
          defaultShowCount={2}
          simple={false}
          showTotalAmount={false}
        />
      </DetailCard>
      <CommentCard order={order} queryParams={orderQueryParams} />
    </div>
  );
};
